import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowRightSvg } from "./IconArrowRightSvg.mjs";
const IconArrowRight = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowRightSvg, ...iconProps });
};
export {
  IconArrowRight
};
